import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';

export function generateTimestamp(): number {
    return Math.floor(Date.now() / 1000); // 秒级时间戳
}

// UUID + 随机数 → 有效避免重复
export function generateNonce(): string {
    const random = CryptoJS.lib.WordArray.random(16).toString();
    return `${uuidv4()}-${random}`;
}

/**
 * 生成签名
 * 按 key 排序，拼接字符串，再 SHA256
 */
export function generateSign(params: Record<string, any>, requesturl: string): string {
    const sortedKeys = Object.keys(params).sort();

    const baseString = sortedKeys.map(key => `${key}=${params[key]}`).join('&');

    const finalString = `${baseString}&uri=${encodeURIComponent(requesturl)}`;

    return CryptoJS.SHA256(finalString.toLowerCase()).toString();
}
